import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Some ISP transparent caching proxies (common on Indian mobile/broadband
// networks) cache and replay GET responses purely by URL, ignoring
// Cache-Control entirely. Appending a cache-busting query param to every
// /api/ request gives each one a unique URL so such a proxy can never
// have a stale cached copy to serve.
const originalFetch = window.fetch;
window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : input?.url;
  if (url && url.includes('/api/')) {
    const bust = `_cb=${Date.now()}`;
    const busted = url.includes('?') ? `${url}&${bust}` : `${url}?${bust}`;
    if (typeof input === 'string') {
      input = busted;
    } else {
      input = new Request(busted, input);
    }
  }
  return originalFetch.call(this, input, init);
};

// If a JS chunk fails to load (stale cache served old index.html pointing to
// deleted chunk files), reload the page once to pick up the new build.
window.addEventListener('error', (event) => {
  const src = event?.target?.src || event?.target?.href || '';
  if (src.includes('/static/')) {
    const reloaded = sessionStorage.getItem('chunk-reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk-reload', '1');
      window.location.reload();
    }
  }
}, true);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();